import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExportBLSecondDT = (props) => {
  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Container No.Seal No Marks & Numbers</Form.Label>
                  <Form.Control
                    type="text"
                    autoComplete="off"
                    placeholder=""
                    name="ConNoSealNOMarks"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.ConNoSealNOMarks
                        ? props.pageValuesData.ConNoSealNOMarks
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>
                    No of Container or Pkg.kind of Packagees: Discription of
                    goods
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="NoOfConPKGDesc"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.NoOfConPKGDesc
                        ? props.pageValuesData.NoOfConPKGDesc
                        : ""
                    }
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Freight and Chargers</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="FreightChargers"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.ConNoSealNOMarks
                        ? props.pageValuesData.ConNoSealNOMarksi
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Revenue tons</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="RevenueTons"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.RevenueTons
                        ? props.pageValuesData.RevenueTons
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Rate</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="Rate"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.Rate ? props.pageValuesData.Rate : ""
                    }
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Per</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="Per"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.Per ? props.pageValuesData.Per : ""
                    }
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Prepaid</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder=""
                    name="Prepaid"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.Prepaid
                        ? props.pageValuesData.Prepaid
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Collect</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="Collect"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.Collect
                        ? props.pageValuesData.Collect
                        : ""
                    }
                    placeholder=""
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="MasterBL">
                  <Form.Label>Exchange Rate</Form.Label>
                  <Form.Control
                    type="text"
                    name="ExchangeRate"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.ExchangeRate
                        ? props.pageValuesData.ExchangeRate
                        : ""
                    }
                    autoComplete="off"
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Prepaid at</Form.Label>
                  <Form.Control
                    type="text"
                    name="PrepaidAt"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.PrepaidAt
                        ? props.pageValuesData.PrepaidAt
                        : ""
                    }
                    placeholder=""
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Payable at</Form.Label>
                  <Form.Control
                    type="text"
                    name="PayableAt"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.PayableAt
                        ? props.pageValuesData.PayableAt
                        : ""
                    }
                    placeholder=""
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Total Paid in national Currency</Form.Label>
                  <Form.Control
                    type="text"
                    name="TotPaidNationalCurr"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.TotPaidNationalCurr
                        ? props.pageValuesData.TotPaidNationalCurr
                        : ""
                    }
                    autoComplete="off"
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Place and Date of issue</Form.Label>
                  <Form.Control
                    type="text"
                    name="PlaceAndDateOfIssue"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.PlaceAndDateOfIssue
                        ? props.pageValuesData.PlaceAndDateOfIssue
                        : ""
                    }
                    placeholder=""
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>No. of original Waybill</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="NoOfOrginalWayBill"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.NoOfOrginalWayBill
                        ? props.pageValuesData.NoOfOrginalWayBill
                        : ""
                    }
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ExportBLSecondDT;
